module.exports = __webpack_public_path__ + "img/code_icon.173f8d8.png";